import { TimeAxisRangeInput, TimeAxisType } from "@/gql/types";
import moment from "moment";

export enum TIME_FRAME {
  THIS_DAY = "this day",
  THIS_WEEK = "this week",
  THIS_MONTH = "this month",
  THIS_QUARTER = "this quarter",
  LAST_DAY = "last day",
  LAST_WEEK = "last week",
  LAST_MONTH = "last month",
  LAST_QUARTER = "last quarter",
}

export const TimeFrameHelper = {
  last_month: (): TimeAxisRangeInput => {
    const val = moment(Date.now())
      .subtract(1, "month")
      .format("YYYY-MM-DD");
    return { type: TimeAxisType.Month, values: [val] };
  },
  asArray: () => [
    TIME_FRAME.THIS_WEEK,
    TIME_FRAME.LAST_WEEK,
    TIME_FRAME.THIS_MONTH,
    TIME_FRAME.LAST_MONTH,
  ],
  getTimeValue: (f: TIME_FRAME): string => {
    const currentTime = moment(Date.now());
    switch (f) {
      case TIME_FRAME.THIS_DAY:
      case TIME_FRAME.THIS_WEEK:
      case TIME_FRAME.THIS_MONTH:
        return currentTime.format("YYYY-MM-DD");
      case TIME_FRAME.LAST_WEEK:
        return currentTime.subtract(1, "week").format("YYYY-MM-DD");
      case TIME_FRAME.LAST_MONTH:
      default:
        return currentTime.subtract(1, "month").format("YYYY-MM-DD");
    }
    /*  return f.startsWith("this")
      ? currentTime.format("YYYY-MM-DD")
      : currentTime.subtract(1, "week").format("YYYY-MM-DD"); */
  },
  getTimeRangeValue: (
    f: TIME_FRAME,
    formatType: "YYYY-MM-DD" | "ll" = "YYYY-MM-DD"
  ): string => {
    const currentTime = () => moment(Date.now());
    const today = currentTime().format(formatType);
    switch (f) {
      case TIME_FRAME.THIS_DAY:
        return today + " - " + today;
      case TIME_FRAME.THIS_WEEK:
        return (
          currentTime()
            .subtract(1, "week")
            .format(formatType) +
          " - " +
          today
        );
      case TIME_FRAME.THIS_MONTH:
        return (
          currentTime()
            .subtract(1, "month")
            .format(formatType) +
          " - " +
          today
        );
      case TIME_FRAME.LAST_WEEK:
        return (
          currentTime()
            .subtract(2, "week")
            .format(formatType) +
          " - " +
          currentTime()
            .subtract(1, "week")
            .format(formatType)
        );
      case TIME_FRAME.LAST_MONTH:
      default:
        return (
          currentTime()
            .subtract(2, "month")
            .format(formatType) +
          " - " +
          currentTime()
            .subtract(1, "month")
            .format(formatType)
        );
    }
    /*  return f.startsWith("this")
      ? currentTime.format("YYYY-MM-DD")
      : currentTime.subtract(1, "week").format("YYYY-MM-DD"); */
  },
  asString(tf: TIME_FRAME): string {
    switch (tf) {
      case TIME_FRAME.THIS_WEEK:
        return "this week";
      case TIME_FRAME.THIS_MONTH:
        return "this month";
      case TIME_FRAME.LAST_WEEK:
        return "last week";
      case TIME_FRAME.LAST_MONTH:
      default:
        return "last month";
    }
  },
  asTimeAxisRangeInput: (f: TIME_FRAME): TimeAxisRangeInput => {
    let type;
    switch (f) {
      case TIME_FRAME.THIS_DAY:
      case TIME_FRAME.LAST_DAY:
        type = TimeAxisType.Day;
        break;
      case TIME_FRAME.THIS_WEEK:
      case TIME_FRAME.LAST_WEEK:
        type = TimeAxisType.Week;
        break;
      case TIME_FRAME.THIS_MONTH:
      case TIME_FRAME.LAST_MONTH:
      default:
        type = TimeAxisType.Month;
        break;
    }
    return {
      type,
      values: [TimeFrameHelper.getTimeValue(f)],
    };
  },
  asTotalAxisRangeInput: (): TimeAxisRangeInput => {
    return {
      type: TimeAxisType.Total,
      values: [TimeFrameHelper.getTimeValue(TIME_FRAME.THIS_DAY)],
    };
  },
};
